import img_1 from './images/img_1.png'
import img_2 from './images/img_2.png'
import img_3 from './images/img_3.png'
import img_4 from './images/img_4.png'
import img_5 from './images/img_5.png'
import img_6 from './images/img_6.png'
import img_7 from './images/img_7.png'
import img_8 from './images/img_8.png'
import team_1 from './images/team_1.jpg'
import team_2 from './images/team_2.jpg'
import team_3 from './images/team_3.jpg'
import team_4 from './images/team_4.jpg'

import arrow from './icons/arrow.png'
import goal_1 from './icons/goal_1.png'
import goal_2 from './icons/goal_2.png'
import product_1 from './icons/product_1.png'
import product_2 from './icons/product_2.png'
import product_3 from './icons/product_3.png'
import product_4 from './icons/product_4.png'
import logo1 from './icons/logo1.svg'

const images = {
    home : {
        img_1,//1-3 are for home page
        img_2,
        img_3,
        img_4, //4-7 are for landing page
        img_5,
        img_6,
        img_7,
        img_8,//services
        team_1, //team members
        team_2,
        team_3,
        team_4, 
    },
    icons: {
        logo1,
        arrow, //these 4 for home page
        product_1,
        product_2,
        product_3,
        product_4,
        goal_1, // for landing page
        goal_2,

    }
}

export default images ;